import React from 'react'
import './Home.css'
import image from '../Assets/home.png'

function Home() {
  return (
    <div className='home'>
      <img src={image} alt=''/>
      
    </div>
  )
}

export default Home
